<template>
  <div
    v-if="tinyMceApiKey.length"
    id="wysywigWrapper"
    ref="wrapper"
    :class="`wrapper ${deviceClass === 'web' ? 'web' : 'mobile'}`"
  >
    <div
      class="preview-width-wrapper"
      role="group"
      aria-label="Preview width"
    >
      <button
        v-for="device in devices"
        :key="device.key"
        type="button"
        :class="['preview-width-option', { 'is-active': deviceClass === device.key }]"
        :aria-pressed="String(deviceClass === device.key)"
        @click="handlePreviewWidth(device.key)"
      >
        <app-icon
          :name="device.icon"
          :size="18"
        />
        {{ device.label }}
      </button>
    </div>
    <Editor
      :api-key="tinyMceApiKey"
      :value="value"
      :init="wysiwygConfig"
      @input="update"
    />
  </div>
</template>
<script>
import Editor from '@tinymce/tinymce-vue'
import {configurationsService} from "@/services/configurations";
import initCustomButtonPlugin from "@/shared/wysiwyg-component/plugins/custombutton";
import AppIcon from "@/shared/app-icon/AppIcon";

export default {
  name: 'WysiwygComponent',
  components: {AppIcon, Editor},
  props: {
    value: {
      required: false,
      default: ''
    },
    disabled: {
      required: false,
      default: false,
      type: Boolean,
    },
    theme: {
      required: false,
      default: 'white',
      type: String,
    }
  },


  data() {
    return {
      tinyMceApiKey: '',
      deviceClass: 'web',
      devices: [
        { key: 'web', label: 'Desktop', icon: 'desktop_windows' },
        { key: 'mobile', label: 'Mobile', icon: 'smartphone' },
      ],
      wysiwygConfig: {
        width: '100%',
        height: '600px',
        paste_data_images: true,
        automatic_uploads: false,
        powerpaste_allow_local_images: true,
        skin: 'material-classic',
        custom_elements:"style",
        content_css: this.theme === 'dark' ? '/wysiwyg-styles-dark.css' : '',
        plugins: 'custombutton print preview casechange importcss tinydrive searchreplace autolink autosave save directionality advcode visualblocks visualchars fullscreen image link media mediaembed template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists checklist wordcount imagetools textpattern noneditable help formatpainter permanentpen pageembed charmap mentions quickbars emoticons advtable export',
        toolbar: 'custombutton | undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media pageembed template link anchor codesample | a11ycheck ltr rtl | showcomments addcomment',
        setup: this.handleSetup,
        extended_valid_elements: '*[*]',

        images_upload_handler: () => {},
      }
    }
  },

  async created() {
    this.tinyMceApiKey = await configurationsService.findOnlineGeneralConfiguration('tinyMceApiKey')
  },

  methods: {
    update(newValue) {
      this.$emit('input', newValue);
    },

    handleSetup(editor) {
      this.loadPlugins();
      editor.on('ExecCommand', function() {
        editor.fire('input');
      });
    },

    loadPlugins() {
      window.tinymce.PluginManager.add('custombutton', initCustomButtonPlugin)
    },

    handlePreviewWidth(deviceClass) {
      this.deviceClass = deviceClass
    }
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;

  &.mobile {
    width: 375px;
  }
}

// segmented Desktop / Mobile toggle
.preview-width-wrapper {
  display: inline-flex;
  gap: 2px;
  margin: 0 0 12px;
  padding: 3px;
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  background-color: var(--bg-subtle);
}

.preview-width-option {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  padding: 0 12px;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--text-secondary);
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    color: var(--text-primary);
  }

  &:focus-visible {
    box-shadow: var(--focus-ring);
  }

  &.is-active {
    background-color: var(--bg-surface);
    box-shadow: var(--shadow-sm);
    color: var(--text-primary);
    font-weight: 600;
  }
}

// rounded frame around TinyMCE
.wrapper ::v-deep .tox-tinymce {
  width: 100%;
  border: 1px solid var(--border-default) !important;
  border-radius: var(--radius-lg) !important;
}
</style>

